import { render, staticRenderFns } from "./OptionMappingSetting.vue?vue&type=template&id=2943f21c&scoped=true"
import script from "./OptionMappingSetting.vue?vue&type=script&lang=js"
export * from "./OptionMappingSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2943f21c",
  null
  
)

export default component.exports